import React, { Suspense } from "react"

const StandalonePricingEmbedContainer = React.lazy(
  () =>
    import(
      "./StandalonePricingEmbedContainer" /* webpackChunkName: "StandalonePricingEmbedContainer" */
    )
)

function LazyStandalonePricingEmbedContainer(props: any) {
  return (
    <Suspense fallback={null}>
      <StandalonePricingEmbedContainer {...props} />
    </Suspense>
  )
}

export default LazyStandalonePricingEmbedContainer
